///<reference path="../require.d.ts"/>

import {Room} from "../models/Room";
import {Price} from "../models/Price";
import {SearchResult} from "../models/SearchResult";
import {CheckedRoomRepository} from "../services/CheckedRoomRepository";

class RoomsController {

    static $inject = ["$element", "$http", 'CheckedRoomRepository'];

    rooms: Room[];

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $http: angular.IHttpService,
        private checked: CheckedRoomRepository
    ) {
        const params = $element.data("params");
        const query = jQuery.param(params);
        const limit = location.pathname === '/' ? 20 : 200;
        $http.get<SearchResult<Room>>(`${apiRoot}/rooms?${query}&limit=${limit}`).success((result) => {
            this.rooms = result.items;
            this.updateChecked();
        });
    }

    transport(r: Room): string {
        if (!r.stations || r.stations.length === 0) return '';
        const s = r.stations[0];
        if (!!s.walk_minutes) {
            return `徒歩${s.walk_minutes}分`;
        } else {
            return s.transport;
        }
    }

    isChecked(id: number): boolean {
        return this.checked.isChecked(id);
    }

    toggle(id: number): void {
        this.checked.toggle(id);
        this.updateChecked();
    }

    updateChecked(): void {
        const ids = this.checked.load();
        this.rooms.forEach((r: Room) => {
            r.checked = this.checked.isChecked(r.id, ids);
        });
    }

    hasPrice(r: Room): boolean {
        return angular.isArray(r.prices) &&
            r.prices.length >= 1 &&
            r.prices.some((p) => p.days === 30);
    }

    mainPrice(r: Room): string {
        if (!r.prices) return null;
        const p = r.prices.filter((p: Price) => p.days === 30)[0];
        if (!!p) {
            const total = numbro(p.total_price / 10000.0).format('0,0.0');
            const daily = numbro(p.daily_rent).format('0,0');
            return `${total}万円/月 ${daily}円/日(賃料)`;
        } else {
            return null;
        }
    }

}

angular.module('hp').controller('RoomsController', RoomsController);



// WEBPACK FOOTER //
// ./controllers/RoomsController.ts